import {createStore} from 'vuex';
import basket from './modules/basket';
import favorite from './modules/favorite';
import compare from './modules/compare';
import user from './modules/user';
import location from './modules/location';

const store = createStore({
	modules: {
		basket,
		favorite,
		compare,
		user,
		location
	}
});

export default store;